module.exports = __webpack_public_path__ + "img/spin.5f36617a.png";